import { useState, useEffect } from 'react';
import { s3 } from 'Services/AWS/s3';

const useLesson = ({ selectedLesson }) => {
  const [contentUrl, setContentUrl] = useState(null);

  useEffect(() => {
    // Si no hay archivo no se hace nada.
    if (!selectedLesson?.file) return;

    // Si hay un archivo generamos una URL firmada para poder visualizarlo.
    s3.getSignedUrl(selectedLesson?.file).then(data => {
      setContentUrl(data?.signedUrl ?? '');
    });
  }, [selectedLesson]);

  return {
    contentUrl,
  };
};

export default useLesson;
